export const ChargingStationConstant = {
  CHARGING_STATION_SAGA: "CHARGING_STATION_SAGA",
  CHARGING_STATION_REQUEST: "CHARGING_STATION_REQUEST",
  CHARGING_STATION_RESPONSE: "CHARGING_STATION_RESPONSE",
  CHARGING_STATION_API: "/all/charging-stations",

  CHARGING_STATION_DETAIL_SAGA: "CHARGING_STATION_DETAIL_SAGA",
  CHARGING_STATION_DETAIL_REQUEST: "CHARGING_STATION_DETAIL_REQUEST",
  CHARGING_STATION_DETAIL_RESPONSE: "CHARGING_STATION_DETAIL_RESPONSE",
  CHARGING_STATION_DETAIL_API: "/charging-station/dealer/:id",

  // GET_CHARGER_POINT_DROPDOWN :"charging-points/connector-dropdowns",
  
  GET_CHARGER_CONNECTOR_DROPDOWN_SAGE: "GET_CHARGER_CONNECTOR_DROPDOWN_SAGE",
  GET_CHARGER_CONNECTOR_DROPDOWN_REQUEST: "GET_CHARGER_CONNECTOR_DROPDOWN_REQUEST",
  GET_CHARGER_CONNECTOR_DROPDOWN_RESPONSE: "GET_CHARGER_CONNECTOR_DROPDOWN_RESPONSE",
  GET_CHARGER_CONNECTOR_DROPDOWN_API: "/charging-points/connector-dropdowns",

  POST_CHARGING_STATION_BULK_SAGA: "POST_CHARGING_STATION_BULK_SAGA",
    POST_CHARGING_STATION_BULK_REQUEST: "POST_CHARGING_STATION_BULK_REQUEST",
    POST_CHARGING_STATION_BULK_RESPONSE: "POST_CHARGING_STATION_BULK_RESPONSE",
    POST_CHARGING_STATION_BULK_API: "/import-connectors",

  ADD_CHARGING_POINT_API: "/charging-point",

  ADD_CHARGING_CONNECTOR_API: "/charging-point/add-connector",

  EDIT_CHARGING_POINT_API: "/charging-point",

  EDIT_CHARGING_CONNECTOR_API: "/charging-point/update-connector",

  CHARGING_STATION_DELETE_SAGA: "CHARGING_STATION_DELETE_SAGA",
  CHARGING_STATION_DELETE_REQUEST: "CHARGING_STATION_DELETE_REQUEST",
  CHARGING_STATION_DELETE_RESPONSE: "CHARGING_STATION_DELETE_RESPONSE",
  CHARGING_STATION_DELETE_API: "/charging-station/:id",

  GET_CHARGING_POINT_API: "/charging-points",
  GET_CHARGING_POINT_REQUEST: "GET_CHARGING_POINT_REQUEST",
  GET_CHARGING_POINT_RESPONSE: "GET_CHARGING_POINT_RESPONSE",
    GET_CHARGING_POINT_SAGA: "GET_CHARGING_POINT_SAGA",

  DELETE_CHARGING_CONNECTOR_API: "/charging-point/delete-connector/:id",
  DELETE_CHARGING_CONNECTOR_REQUEST: "DELETE_CHARGING_CONNECTOR_REQUEST",
  DELETE_CHARGING_CONNECTOR_RESPONSE: "DELETE_CHARGING_CONNECTOR_RESPONSE",
  DELETE_CHARGING_CONNECTOR_SAGA: "DELETE_CHARGING_CONNECTOR_SAGA",

  GET_VENDOR_SELECT_WISE_API: "/vendors",
  GET_VENDOR_SELECT_WISE_REQUEST: "GET_VENDOR_SELECT_WISE_REQUEST",
  GET_VENDOR_SELECT_WISE_RESPONSE: "GET_VENDOR_SELECT_WISE_RESPONSE",
  GET_VENDOR_SELECT_WISE_SAGA: "GET_VENDOR_SELECT_WISE_SAGA",

  ENABLE_DESABLE_CHARGING_TABLE_SAGA: "ENABLE_DESABLE_CHARGING_TABLE_SAGA",
  ENABLE_DESABLE_CHARGING_TABLE_REQUEST:
    "ENABLE_DESABLE_CHARGING_TABLE_REQUEST",
  ENABLE_DESABLE_CHARGING_TABLE_RESPONSE:
    "ENABLE_DESABLE_CHARGING_TABLE_RESPONSE",
  ENABLE_DESABLE_CHARGING_TABLE_API: "/enable-disable-station",

  //charging startion count
  CHARGING_STATION_COUNT_SAGA: "CHARGING_STATION_COUNT_SAGA",
  CHARGING_STATION_COUNT_REQUEST: "CHARGING_STATION_COUNT_REQUEST",
  CHARGING_STATION_COUNT_RESPONSE: "CHARGING_STATION_COUNT_RESPONSE",
  CHARGING_STATION_COUNT_API: "/all/charging-stations",

  //charging all request

  CHARGING_SEEALLRES_SAGA: "CHARGING_SEEALLRES_SAGA",
  CHARGING_SEEALLRES_REQUEST: "CHARGING_SEEALLRES_REQUEST",
  CHARGING_SEEALLRES_RESPONSE: "CHARGING_SEEALLRES_RESPONSE",
  CHARGING_SEEALLRES_API: "/station/requests",

  // CSED enable disable

  CHARGING_APPROVE_DISABLE_SAGA: "CHARGING_APPROVE_DISABLE_SAGA",
  CHARGING_APPROVE_DISABLE_REQUEST: "CHARGING_APPROVE_DISABLE_REQUEST",
  CHARGING_APPROVE_DISABLE_RESPONSE: "CHARGING_APPROVE_DISABLE_RESPONSE",
  CHARGING_APPROVE_DISABLE_API: "/approve-reject-station",

  CHARGING_STATION_DELETE_API:"/delete-station",

  CHARGING_STATION_NETWORK_SAGA: "CHARGING_STATION_NETWORK_SAGA",
  CHARGING_STATION_NETWORK_REQUEST: "CHARGING_STATION_NETWORK_REQUEST",
  CHARGING_STATION_NETWORK_RESPONSE: "CHARGING_STATION_NETWORK_RESPONSE",
  CHARGING_STATION_NETWORK_API:"/network-dropdown"

};
